export enum AvatarMenuTab {
  Practice = 'practice',
  Payment = 'payment',
  RewardStatus = 'rewardStatus',
  Account = 'account',
  Credit = 'credit',
}
